module.exports = __webpack_public_path__ + "static/media/DOPPLE-DOP-LP.d760d95b.svg";